<div class="app-spinner">
    <p-progressSpinner [style]="{width: '36px', height: '36px'}"
                       [animationDuration]="'1s'"
                       [strokeWidth]="'5'">
    </p-progressSpinner>
</div>